/**
 * Errors raised by domain rules. `code` matches the error catalogue in
 * docs/05-api-contracts.md section 15, so the API maps them without translation.
 */
export class DomainRuleError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = "DomainRuleError";
        this.code = code;
    }
}
export class InvalidTransitionError extends DomainRuleError {
    machine;
    state;
    event;
    constructor(machine, state, event) {
        super("INVALID_TRANSITION", `${machine}: event "${event}" is not allowed in state "${state}"`);
        this.name = "InvalidTransitionError";
        this.machine = machine;
        this.state = state;
        this.event = event;
    }
}
//# sourceMappingURL=errors.js.map